{
  "CHAT_LIST": {
    "LOADING": "Načítání konverzací",
    "LOAD_MORE_CONVERSATIONS": "Načíst více konverzací",
    "EOF": "Všechny konverzace načteny 🎉",
    "LIST": {
      "404": "V této skupině nejsou žádné aktivní konverzace."
    },
    "FAILED_TO_SEND": "Odeslání selhalo",
    "TAB_HEADING": "Konverzace",
    "MENTION_HEADING": "Zmínky",
    "UNATTENDED_HEADING": "Neobsloužené",
    "SEARCH": {
      "INPUT": "Hledat lidi, chaty, Uložené odpovědi .."
    },
    "SEARCH_MESSAGES": "Hledat konverzace",
    "SEARCH_INPUT_PLACEHOLDER": "Hledat konverzace...",
    "FILTER_ALL": "Vše",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Moje",
      "unassigned": "Nepřiřazeno",
      "all": "Vše"
    },
    "MESSAGE_USE_AS_TEMPLATE": "Přidat do odpovědi",
    "CARDS": {
      "ACTIONS": {
        "OPEN": "Otevřít",
        "BUY": "Koupit"
      }
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Otevřené"
      },
      "resolved": {
        "TEXT": "Vyřešené"
      },
      "pending": {
        "TEXT": "Čekající"
      },
      "snoozed": {
        "TEXT": "Odložené"
      },
      "all": {
        "TEXT": "Vše"
      }
    },
    "VIEW_FILTER": "Zobrazit",
    "SORT_TOOLTIP_LABEL": "Seřadit konverzace",
    "CHAT_SORT": {
      "STATUS": "Stav",
      "ORDER_BY": "Seřadit podle"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": "Vytvořeno:",
      "LAST_ACTIVITY": "Poslední aktivita:",
      "LAST_CUSTOMER_MESSAGE": "Poslední zpráva od zákazníka:"
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Poslední aktivita: od nejstarších"
      },
      "last_activity_at_desc": {
        "TEXT": "Poslední aktivita: od nejnovějších"
      },
      "last_customer_message_at_asc": {
        "TEXT": "Poslední zpráva od zákazníka: od nejstarších"
      },
      "last_customer_message_at_desc": {
        "TEXT": "Poslední zpráva od zákazníka: od nejnovějších"
      },
      "created_at_desc": {
        "TEXT": "Vytvořeno: od nejnovějších"
      },
      "created_at_asc": {
        "TEXT": "Vytvořeno: od nejstarších"
      },
      "priority_desc": {
        "TEXT": "Priorita: od nejvyšší"
      },
      "priority_asc": {
        "TEXT": "Priorita: Od nejnižší"
      },
      "priority_created_at_desc": {
        "TEXT": "Priorita + Vytvořeno: od nejnovějších"
      },
      "priority_created_at_asc": {
        "TEXT": "Priorita + Vytvořeno: od nejstarších"
      },
      "waiting_since_asc": {
        "TEXT": "Čeká na odpověď: Nejdelší první"
      },
      "waiting_since_desc": {
        "TEXT": "Čeká na odpověď: Nejkratší první"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Zpráva obrázku"
      },
      "audio": {
        "CONTENT": "Zvuková zpráva"
      },
      "video": {
        "CONTENT": "Video zpráva"
      },
      "file": {
        "CONTENT": "Přílohu souboru"
      },
      "location": {
        "CONTENT": "Poloha"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "sdílel URL"
      },
      "contact": {
        "CONTENT": "Sdílený kontakt"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Seřadit konverzace",
      "DROPDOWN_TITLE": "Seřadit podle",
      "ITEMS": {
        "LATEST": {
          "NAME": "Poslední aktivita v",
          "LABEL": "Poslední aktivita"
        },
        "CREATED_AT": {
          "NAME": "Vytvořeno",
          "LABEL": "Vytvořeno"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Poslední zpráva uživatele v",
          "LABEL": "Poslední zpráva"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Obdrženo e-mailem",
    "VIEW_TWEET_IN_TWITTER": "Zobrazit tweet na Twitteru",
    "REPLY_TO_TWEET": "Odpovědět na tento tweet",
    "LINK_TO_STORY": "Přejít na instagram příběh",
    "SENT": "Úspěšně odesláno",
    "READ": "Úspěšně přečteno",
    "DELIVERED": "Úspěšně doručeno",
    "NO_MESSAGES": "Žádné zprávy",
    "NO_CONTENT": "Žádný obsah k dispozici",
    "HIDE_QUOTED_TEXT": "Skrýt citovaný text",
    "SHOW_QUOTED_TEXT": "Zobrazit citovaný text",
    "HIDE_AUTOMATED_MESSAGE": "Skrýt obsah automatické odpovědi",
    "SHOW_AUTOMATED_MESSAGE": "Zobrazit obsah automatické odpovědi",
    "AUTOMATED_MESSAGE": "Automatická odpověď",
    "MESSAGE_READ": "Přečtené",
    "SENDING": "Odesílá se"
  }
}
